import React from "react";
import NewsletterTwentyNine from "../component/NewsletterTwentyNine";

function NewsletterTwentyNineContainer() {
  return <NewsletterTwentyNine />;
}

export default NewsletterTwentyNineContainer;
